/* eslint-disable array-callback-return */
import React, { useState, useRef, useContext, useEffect } from "react"
import { Fieldset } from "primereact/fieldset"
import PropTypes from "prop-types"
import { Toast } from "primereact/toast"
import { Toolbar } from "primereact/toolbar"
import CustomToolBar from "../../../ToolBar/customToolbar"
import { errorMessages } from "../../../types/messages"
import {
  existsErrors,
  getAdditionalQuestions,
  showMessage,
  showQuestion,
  updateState,
  validateQuestions,
  formatMixedQuestions,
  filterAdditionalQuestions,
  checkDisplayConditional,
  checkConditionalRender,
  prevForm,
  nextForm,
} from "../../../utils/utils"
import ServicesRow from "../../B/PlannedServices/ServicesRow"
import { GpraContext } from "../../../../../context/gpraContext"
import { endpoints } from "../../../../../config/gpraApiEndpoints"
import FormLabel from "../../../Common/FormLabel"
import FormError from "../../../Common/FormError"
import gpraStyles from "../../../../../styles/Participant-GPRA.module.css"
import { INTERVIEW_SECTIONS } from "../../../types/interviewTypes"
import { InputText } from "primereact/inputtext"
import AdditionalQuestionContainer from "../../Additional/AdditionalQuestionContainer"
import { UserContext } from "../../../../../context/userContext"

const ServicesReceived3 = (props) => {
  const { showToolBar, disabled } = props
  const {
    handleSubmitPut,
    interview,
    handleLoadPrev,
    handleLoadNext,
    handleSectionsCompleted,
    sectionsCompleted,
    questions,
    updateInterviewValues,
    additionalQuestions,
    activeIndex,
    sections,
    administrativeInterview,
    editMode,
  } = useContext(GpraContext)

  const userCtx = useContext(UserContext)

  const [validationErrors, setValidationErrors] = useState({})
  const [servicesReceived3, setServicesReceived3] = useState(
    interview[INTERVIEW_SECTIONS.SERVICES_RECEIVED_3]
  )
  const [mixedQuestions, setMixedQuestions] = useState([])

  useEffect(() => {
    if (mixedQuestions.length === 0) {
      let filteredQuestions = []
      let filteredAdditional = []
      if (questions) {
        filteredQuestions = questions.filter(
          (q) => q.section === INTERVIEW_SECTIONS.SERVICES_RECEIVED_3
        )
      }
      if (additionalQuestions) {
        filteredAdditional = filterAdditionalQuestions(
          additionalQuestions,
          INTERVIEW_SECTIONS.SERVICES_RECEIVED_3
        )
      }
      setMixedQuestions(
        formatMixedQuestions(filteredQuestions, filteredAdditional)
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions, additionalQuestions])

  const toast = useRef(null)

  const saveData = (setNextForm, previousForm, setNavigationItem) => {
    updateInterviewValues(
      INTERVIEW_SECTIONS.SERVICES_RECEIVED_3,
      servicesReceived3
    )
    if (previousForm) {
      handleLoadPrev(true)
      setNextForm(prevForm(sections, activeIndex, administrativeInterview))
      setNavigationItem()
    } else {
      if (validForm()) {
        handleLoadNext(true)
        handleSubmitPut(endpoints.SAVE_SERVICESRECEIVED3_DATA, {
          GpraKCm1: servicesReceived3?.gpra_k_cm_1,
          GpraKCm2: servicesReceived3?.gpra_k_cm_2,
          GpraKCm3a: servicesReceived3?.gpra_k_cm_3a,
          GpraKCm3b: servicesReceived3?.gpra_k_cm_3b,
          GpraKCm4: servicesReceived3?.gpra_k_cm_4,
          GpraKCm5: servicesReceived3?.gpra_k_cm_5,
          GpraKCm6a: servicesReceived3?.gpra_k_cm_6a,
          GpraKCm6b: servicesReceived3?.gpra_k_cm_6b,
          GpraKCm6c: servicesReceived3?.gpra_k_cm_6c,
          GpraKCm7: servicesReceived3?.gpra_k_cm_7,
          GpraKCm8: servicesReceived3?.gpra_k_cm_8,
          GpraKCm9: servicesReceived3?.gpra_k_cm_9,
          GpraKCm10: servicesReceived3?.gpra_k_cm_10,
          GpraKCm10a: servicesReceived3?.gpra_k_cm_10a,
          GpraKMs1: servicesReceived3?.gpra_k_ms_1,
          GpraKMs2: servicesReceived3?.gpra_k_ms_2,
          GpraKMs3: servicesReceived3?.gpra_k_ms_3,
          GpraKMs4: servicesReceived3?.gpra_k_ms_4,
          GpraKMs5: servicesReceived3?.gpra_k_ms_5,
          GpraKMs6: servicesReceived3?.gpra_k_ms_6,
          GpraKMs7: servicesReceived3?.gpra_k_ms_7,
          GpraKMs8: servicesReceived3?.gpra_k_ms_8,
          GpraKMs8a: servicesReceived3?.gpra_k_ms_8a,
          GpraKAcs1: servicesReceived3?.gpra_k_acs_1,
          GpraKAcs2: servicesReceived3?.gpra_k_acs_2,
          GpraKAcs3: servicesReceived3?.gpra_k_acs_3,
          GpraKAcs4: servicesReceived3?.gpra_k_acs_4,
          GpraKAcs5: servicesReceived3?.gpra_k_acs_5,
          GpraKAcs6: servicesReceived3?.gpra_k_acs_6,
          GpraKAcs6a: servicesReceived3?.gpra_k_acs_6a,
          GpraInterviewId:
            interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          GpraKId: servicesReceived3?.gpra_k_id,
          Additional: getAdditionalQuestions(servicesReceived3),
          EditMode: editMode,
          EditedBy: userCtx.session?.user?.staff_id,
        })
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              handleLoadNext(false)
              setNextForm(
                nextForm(sections, activeIndex, administrativeInterview)
              )
              setNavigationItem()
              handleSectionsCompleted({
                ...sectionsCompleted,
                ...{ servicesReceived3: true },
              })
            }
          })
          .catch(() => {
            handleLoadNext(false)
            showMessage(false, errorMessages.genericError, toast)
          })
      } else {
        showMessage(false, errorMessages.toastErrorDetail, toast)
      }
    }
  }

  const removeError = (key) => {
    validationErrors[key] = null
    setValidationErrors(validationErrors)
  }

  const validForm = () => {
    const errors = {}
    if (
      servicesReceived3?.gpra_k_cm_10 > 0 &&
      !servicesReceived3?.gpra_k_cm_10a &&
      showQuestion(questions, "gpra_k_cm_10")
    ) {
      errors.gpra_k_cm_10a = errorMessages.requiredMessage
    }
    if (
      servicesReceived3?.gpra_k_ms_8 > 0 &&
      !servicesReceived3?.gpra_k_ms_8a &&
      showQuestion(questions, "gpra_k_ms_8")
    ) {
      errors.gpra_k_cm_8a = errorMessages.requiredMessage
    }
    if (
      servicesReceived3?.gpra_k_acs_6 > 0 &&
      !servicesReceived3?.gpra_k_acs_6a &&
      showQuestion(questions, "gpra_k_acs_6")
    ) {
      errors.gpra_k_acs_6a = errorMessages.requiredMessage
    }
    setValidationErrors(
      validateQuestions(
        servicesReceived3,
        INTERVIEW_SECTIONS.SERVICES_RECEIVED_3,
        additionalQuestions,
        errors,
        questions
      )
    )
    return existsErrors(errors)
  }

  const renderDefaultMain = (question) => {
    if (question.field === "gpra_k_cm_1") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel label={`${question.number}. Case Management Services`} />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived3}
              setEntity={setServicesReceived3}
              showDrop={false}
              removeError={removeError}
              label={`1. Family Services (Including Marriage Education, Parenting, Child Development Services)`}
              number={servicesReceived3?.gpra_k_cm_1}
              setNumber={"gpra_k_cm_1"}
              numberError={validationErrors.gpra_k_cm_1}
              numberErrorType="gpra_k_cm_1"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived3}
              setEntity={setServicesReceived3}
              showDrop={false}
              removeError={removeError}
              label={`2. Child Care`}
              number={servicesReceived3?.gpra_k_cm_2}
              setNumber={"gpra_k_cm_2"}
              numberError={validationErrors.gpra_k_cm_2}
              numberErrorType="gpra_k_cm_2"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              showNumber={false}
              showDrop={false}
              removeError={removeError}
              label={`3. Employement Service`}
              summaryDisabled={disabled}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived3}
              setEntity={setServicesReceived3}
              showDrop={false}
              removeError={removeError}
              label="1. Pre-Employment"
              number={servicesReceived3?.gpra_k_cm_3a}
              setNumber={"gpra_k_cm_3a"}
              numberError={validationErrors.gpra_k_cm_3a}
              numberErrorType="gpra_k_cm_3a"
              summaryDisabled={disabled}
              indentation
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived3}
              setEntity={setServicesReceived3}
              showDrop={false}
              removeError={removeError}
              label="2. Employment Coaching"
              number={servicesReceived3?.gpra_k_cm_3b}
              setNumber={"gpra_k_cm_3b"}
              numberError={validationErrors.gpra_k_cm_3b}
              numberErrorType="gpra_k_cm_3b"
              summaryDisabled={disabled}
              indentation
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived3}
              setEntity={setServicesReceived3}
              showDrop={false}
              removeError={removeError}
              label={`4. Individual Services Coordination`}
              number={servicesReceived3?.gpra_k_cm_4}
              setNumber={"gpra_k_cm_4"}
              numberError={validationErrors.gpra_k_cm_4}
              numberErrorType="gpra_k_cm_4"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived3}
              setEntity={setServicesReceived3}
              showDrop={false}
              removeError={removeError}
              label={`5. Transportation`}
              number={servicesReceived3?.gpra_k_cm_5}
              setNumber={"gpra_k_cm_5"}
              numberError={validationErrors.gpra_k_cm_5}
              numberErrorType="gpra_k_cm_5"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              showDrop={false}
              showNumber={false}
              label={`6. HIV/AIDS Services`}
              summaryDisabled={disabled}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived3}
              setEntity={setServicesReceived3}
              showDrop={false}
              removeError={removeError}
              label="1. If HIV Neg, Pre-Exposure Prophylaxis"
              number={servicesReceived3?.gpra_k_cm_6a}
              setNumber={"gpra_k_cm_6a"}
              numberError={validationErrors.gpra_k_cm_6a}
              numberErrorType="gpra_k_cm_6a"
              summaryDisabled={disabled}
              indentation
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived3}
              setEntity={setServicesReceived3}
              showDrop={false}
              removeError={removeError}
              label="2. If HIV Neg, Post-Exposure Prophylaxis"
              number={servicesReceived3?.gpra_k_cm_6b}
              setNumber={"gpra_k_cm_6b"}
              numberError={validationErrors.gpra_k_cm_6b}
              numberErrorType="gpra_k_cm_6b"
              summaryDisabled={disabled}
              indentation
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived3}
              setEntity={setServicesReceived3}
              showDrop={false}
              removeError={removeError}
              label="3. If HIV Positive, HIV Treatment"
              number={servicesReceived3?.gpra_k_cm_6c}
              setNumber={"gpra_k_cm_6c"}
              numberError={validationErrors.gpra_k_cm_6c}
              numberErrorType="gpra_k_cm_6c"
              summaryDisabled={disabled}
              indentation
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived3}
              setEntity={setServicesReceived3}
              showDrop={false}
              removeError={removeError}
              label={`7. Transitional Drug-Free Housing Service`}
              number={servicesReceived3?.gpra_k_cm_7}
              setNumber={"gpra_k_cm_7"}
              numberError={validationErrors.gpra_k_cm_7}
              numberErrorType="gpra_k_cm_7"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived3}
              setEntity={setServicesReceived3}
              showDrop={false}
              removeError={removeError}
              label={`8. Housing Support`}
              number={servicesReceived3?.gpra_k_cm_8}
              setNumber={"gpra_k_cm_8"}
              numberError={validationErrors.gpra_k_cm_8}
              numberErrorType="gpra_k_cm_8"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived3}
              setEntity={setServicesReceived3}
              showDrop={false}
              removeError={removeError}
              label={`9. Health Insurance Enrollment`}
              number={servicesReceived3?.gpra_k_cm_9}
              setNumber={"gpra_k_cm_9"}
              numberError={validationErrors.gpra_k_cm_9}
              numberErrorType="gpra_k_cm_9"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived3}
              setEntity={setServicesReceived3}
              showDrop={false}
              removeError={removeError}
              label={`10. Other Case Management Services (Specify)`}
              number={servicesReceived3?.gpra_k_cm_10}
              setNumber={"gpra_k_cm_10"}
              numberError={validationErrors.gpra_k_cm_10}
              numberErrorType="gpra_k_cm_10"
              summaryDisabled={disabled}
              extraValues={[{ key: "gpra_k_cm_10a", value: "" }]}
              defaultZero={question.defaultZero}
            />
          </div>
          {servicesReceived3?.gpra_k_cm_10 > 0 && (
            <div className={gpraStyles.formRow}>
              <InputText
                className={
                  validationErrors.gpra_k_cm_10a
                    ? gpraStyles.inputText5Error
                    : gpraStyles.inputText5
                }
                disabled={disabled}
                placeholder={
                  !servicesReceived3?.gpra_k_cm_10 ? "Not Applicable" : ""
                }
                value={servicesReceived3?.gpra_k_cm_10a}
                onChange={(e) => {
                  updateState(
                    "gpra_k_cm_10a",
                    e.target.value,
                    null,
                    null,
                    servicesReceived3,
                    setServicesReceived3,
                    null
                  )
                  removeError("gpra_k_cm_10a")
                }}
              />
              <FormError error={validationErrors.gpra_k_cm_10a} />
            </div>
          )}
        </>
      )
    }
    if (question.field === "gpra_k_ms_1") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel label={`${question.number}. Medical Services`} />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived3}
              setEntity={setServicesReceived3}
              showDrop={false}
              removeError={removeError}
              label={`1. Medical Care`}
              number={servicesReceived3?.gpra_k_ms_1}
              setNumber={"gpra_k_ms_1"}
              numberError={validationErrors.gpra_k_ms_1}
              numberErrorType="gpra_k_ms_1"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived3}
              setEntity={setServicesReceived3}
              showDrop={false}
              removeError={removeError}
              label={`2. Alcohol/Drug Testing`}
              number={servicesReceived3?.gpra_k_ms_2}
              setNumber={"gpra_k_ms_2"}
              numberError={validationErrors.gpra_k_ms_2}
              numberErrorType="gpra_k_ms_2"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived3}
              setEntity={setServicesReceived3}
              showDrop={false}
              removeError={removeError}
              label={`3. HIV/AIDS Medical Support & Testing`}
              number={servicesReceived3?.gpra_k_ms_3}
              setNumber={"gpra_k_ms_3"}
              numberError={validationErrors.gpra_k_ms_3}
              numberErrorType="gpra_k_ms_3"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived3}
              setEntity={setServicesReceived3}
              showDrop={false}
              removeError={removeError}
              label={`4. HIV/AIDS Medical Support & Testing`}
              number={servicesReceived3?.gpra_k_ms_4}
              setNumber={"gpra_k_ms_4"}
              numberError={validationErrors.gpra_k_ms_4}
              numberErrorType="gpra_k_ms_4"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived3}
              setEntity={setServicesReceived3}
              showDrop={false}
              removeError={removeError}
              label={`5. Dental Care`}
              number={servicesReceived3?.gpra_k_ms_5}
              setNumber={"gpra_k_ms_5"}
              numberError={validationErrors.gpra_k_ms_5}
              numberErrorType="gpra_k_ms_5"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived3}
              setEntity={setServicesReceived3}
              showDrop={false}
              removeError={removeError}
              label={`6. Viral Hepatitis Medical Support & Testing`}
              number={servicesReceived3?.gpra_k_ms_6}
              setNumber={"gpra_k_ms_6"}
              numberError={validationErrors.gpra_k_ms_6}
              numberErrorType="gpra_k_ms_6"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived3}
              setEntity={setServicesReceived3}
              showDrop={false}
              removeError={removeError}
              label={`7. Other STI Support & Testing`}
              number={servicesReceived3?.gpra_k_ms_7}
              setNumber={"gpra_k_ms_7"}
              numberError={validationErrors.gpra_k_ms_7}
              numberErrorType="gpra_k_ms_7"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived3}
              setEntity={setServicesReceived3}
              showDrop={false}
              removeError={removeError}
              label={`8. Other Medical Services (Specify)`}
              number={servicesReceived3?.gpra_k_ms_8}
              setNumber={"gpra_k_ms_8"}
              numberError={validationErrors.gpra_k_ms_8}
              numberErrorType="gpra_k_ms_8"
              summaryDisabled={disabled}
              extraValues={[{ key: "gpra_k_ms_8a", value: "" }]}
              defaultZero={question.defaultZero}
            />
          </div>
          {servicesReceived3?.gpra_k_ms_8 > 0 && (
            <div className={gpraStyles.formRow}>
              <InputText
                className={
                  validationErrors.gpra_k_ms_8a
                    ? gpraStyles.inputText5Error
                    : gpraStyles.inputText5
                }
                disabled={disabled}
                placeholder={
                  !servicesReceived3?.gpra_k_ms_8 ? "Not Applicable" : ""
                }
                value={servicesReceived3?.gpra_k_ms_8a}
                onChange={(e) => {
                  updateState(
                    "gpra_k_ms_8a",
                    e.target.value,
                    null,
                    null,
                    servicesReceived3,
                    setServicesReceived3,
                    null
                  )
                  removeError("gpra_k_ms_8a")
                }}
              />
              <FormError error={validationErrors.gpra_k_ms_8a} errorType={2} />
            </div>
          )}
        </>
      )
    }
    if (question.field === "gpra_k_acs_1") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel label={`${question.number}. After Care Services`} />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived3}
              setEntity={setServicesReceived3}
              showDrop={false}
              removeError={removeError}
              label={`1. Continuing Care`}
              number={servicesReceived3?.gpra_k_acs_1}
              setNumber={"gpra_k_acs_1"}
              numberError={validationErrors.gpra_k_acs_1}
              numberErrorType="gpra_k_acs_1"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived3}
              setEntity={setServicesReceived3}
              showDrop={false}
              removeError={removeError}
              label={`2. Relapse Prevention`}
              number={servicesReceived3?.gpra_k_acs_2}
              setNumber={"gpra_k_acs_2"}
              numberError={validationErrors.gpra_k_acs_2}
              numberErrorType="gpra_k_acs_2"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived3}
              setEntity={setServicesReceived3}
              showDrop={false}
              removeError={removeError}
              label={`3. Recovery Coaching`}
              number={servicesReceived3?.gpra_k_acs_3}
              setNumber={"gpra_k_acs_3"}
              numberError={validationErrors.gpra_k_acs_3}
              numberErrorType="gpra_k_acs_3"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived3}
              setEntity={setServicesReceived3}
              showDrop={false}
              removeError={removeError}
              label={`4. Self-Help And Support Groups`}
              number={servicesReceived3?.gpra_k_acs_4}
              setNumber={"gpra_k_acs_4"}
              numberError={validationErrors.gpra_k_acs_4}
              numberErrorType="gpra_k_acs_4"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived3}
              setEntity={setServicesReceived3}
              showDrop={false}
              removeError={removeError}
              label={`5. Spiritual Support`}
              number={servicesReceived3?.gpra_k_acs_5}
              setNumber={"gpra_k_acs_5"}
              numberError={validationErrors.gpra_k_acs_5}
              numberErrorType="gpra_k_acs_5"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived3}
              setEntity={setServicesReceived3}
              showDrop={false}
              removeError={removeError}
              label={`6. Other After Case Services (Specify)`}
              number={servicesReceived3?.gpra_k_acs_6}
              setNumber={"gpra_k_acs_6"}
              numberError={validationErrors.gpra_k_acs_6}
              numberErrorType="gpra_k_acs_6"
              summaryDisabled={disabled}
              extraValues={[{ key: "gpra_k_acs_6a", value: "" }]}
              defaultZero={question.defaultZero}
            />
          </div>
          {servicesReceived3?.gpra_k_acs_6 > 0 && (
            <div className={gpraStyles.formRow}>
              <InputText
                className={
                  validationErrors.gpra_k_acs_6a
                    ? gpraStyles.inputText5Error
                    : gpraStyles.inputText5
                }
                disabled={disabled}
                placeholder={
                  !servicesReceived3?.gpra_k_acs_6 ? "Not Applicable" : ""
                }
                value={servicesReceived3?.gpra_k_acs_6a}
                onChange={(e) => {
                  updateState(
                    "gpra_k_acs_6a",
                    e.target.value,
                    null,
                    null,
                    servicesReceived3,
                    setServicesReceived3,
                    null
                  )
                  removeError("gpra_k_acs_6a")
                }}
              />
              <FormError error={validationErrors.gpra_k_acs_6a} />
            </div>
          )}
        </>
      )
    }
  }
  
  return (
    <>
      <Toast ref={toast} />
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mb2}
          right={
            <CustomToolBar
              toast={toast}
              prevForm={true}
              saveData={saveData}
              nextForm={true}
            />
          }
        ></Toolbar>
      )}
      <Fieldset
        legend="K. SERVICES RECEIVED UNDER GRANT FUNDING"
        style={{ marginBottom: "1rem" }}
      >
        <div className={gpraStyles.grid}>
          {mixedQuestions?.map((question) => {
            if (question.kind === "default") {
              if (question.show) {
                return renderDefaultMain(question)
              }
            } else {
              if (
                checkConditionalRender(
                  question.enabled,
                  question.required,
                  question.kind,
                  question.conditionalSource
                )
              ) {
                return (
                  <AdditionalQuestionContainer
                    entity={servicesReceived3}
                    setEntity={setServicesReceived3}
                    errors={validationErrors}
                    section={INTERVIEW_SECTIONS.SERVICES_RECEIVED_3}
                    removeError={removeError}
                    disabled={disabled}
                    question={question.question}
                    number={question.number}
                    kind={question.kind}
                  />
                )
              } else {
                if (checkDisplayConditional(question, servicesReceived3)) {
                  return (
                    <AdditionalQuestionContainer
                      entity={servicesReceived3}
                      setEntity={setServicesReceived3}
                      errors={validationErrors}
                      section={INTERVIEW_SECTIONS.SERVICES_RECEIVED_3}
                      removeError={removeError}
                      disabled={disabled}
                      question={question.question}
                      number={question.number}
                      kind={question.kind}
                    />
                  )
                }
              }
            }
          })}
        </div>
      </Fieldset>
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mt2}
          right={
            <CustomToolBar
              toast={toast}
              prevForm={true}
              saveData={saveData}
              nextForm={true}
            />
          }
        ></Toolbar>
      )}
    </>
  )
}

ServicesReceived3.propTypes = {
  showToolBar: PropTypes.bool,
  disabled: PropTypes.bool,
}

ServicesReceived3.defaultProps = {
  showToolBar: true,
  disabled: false,
}

export default ServicesReceived3
